/**
 * Query parameters to keep in url while navigating through users and permission pages.
 */
export const UsersAndPermissionsWhitelistQuery = ['offset', 'limit', 'search'];
